import type { RouteComponentProps } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

/**
 * Builds a `<Route render>` that redirects to `pathname` while preserving the
 * incoming query string and hash. Entity Routes use this to forward legacy
 * `/list` sub-paths to their new top-level equivalents without dropping
 * deep-link params (e.g. a schedule `?..._id=` filter).
 */
export const renderRedirect =
  (pathname: string) =>
  ({ location }: RouteComponentProps): JSX.Element =>
    (
      <Redirect
        to={{ pathname, search: location.search, hash: location.hash }}
      />
    );

/**
 * Builds a `<Route render>` that swaps `fromPrefix` for `toPrefix` at the start
 * of the current pathname, preserving the rest of the path, the query string,
 * and the hash. Use it to forward a whole retired route tree (e.g.
 * `/block-popups/*` -> `/popups/*`) without enumerating every sub-path.
 */
export const renderPrefixRedirect =
  (fromPrefix: string, toPrefix: string) =>
  ({ location }: RouteComponentProps): JSX.Element =>
    (
      <Redirect
        to={{
          pathname: `${toPrefix}${location.pathname.slice(fromPrefix.length)}`,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
